.root {
	width: 1em;
	height: 1em;
	display: inline-block;
	vertical-align: -0.125em;
}
